// src/components/Form2.jsx
import React, { useRef, useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap"; // NEW
import "../css/contact-form.css";
import { API_BASE_URL } from "../config";
export default function Form2({
  leadSource = "home",
  endpoint = `${API_BASE_URL}/api/contact`,
}) {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    preferredContact: "email",
    bestTime: "any",
    message: "",
    consent: false,
    company: "", // honeypot
  });

  const [status, setStatus] = useState({ sending: false, ok: null, error: "" });

  // --- Modal state (NEW) ---
  const [showModal, setShowModal] = useState(false);
  const closeBtnRef = useRef(null);
  const handleCloseModal = () => setShowModal(false);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((s) => ({ ...s, [name]: type === "checkbox" ? checked : value }));
  };

  const isValid = () => {
    if (!form.fullName.trim()) return false;
    if (!/^\S+@\S+\.\S+$/.test(form.email)) return false;
    if (!form.message.trim()) return false;
    if (!form.consent) return false;
    if (form.company.trim()) return false; // honeypot
    return true;
  };

  const buildPayload = () => {
    return {
      _hp: form.company || "",
      name: form.fullName.trim(),
      email: form.email.trim(),
      phone: form.phone.trim() || "",
      sex: "U",
      age: 30,
      height: 170,
      weight: 70,
      experience: "",
      objective: "Contact request",
      frequency: "-",
      coaching: form.preferredContact,
      timeline: "n/a",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      calltimes: form.bestTime,
      message: form.message.trim(),
      package_type: "contact",
      package_name: "Contact only",
      package_price: 0,
      package_period: "one-off",
      package_compare: null,
      package_saving: null,
      currency: "EUR",
      lead_source: leadSource,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid()) {
      setStatus({
        sending: false,
        ok: false,
        error: "Please fill all required fields correctly.",
      });
      return;
    }

    try {
      setStatus({ sending: true, ok: null, error: "" });

      const payload = buildPayload();

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || `HTTP ${res.status}`);
      }

      // ✅ Successo: reset parziale + mostra modal
      setStatus({ sending: false, ok: true, error: "" });
      setForm((s) => ({
        ...s,
        message: "",
        consent: false,
      }));
      setShowModal(true); // NEW
    } catch (err) {
      console.error("Submit error:", err);
      setStatus({
        sending: false,
        ok: false,
        error: "Unable to send your request. Please try again.",
      });
    }
  };

  return (
    <section className="contact-form-wrap1">
      <Container>
        <Row className="justify-content-center">
          <Col lg={9} xl={8}>
            <header className="text-center mb-4 mt-4">
              <h2 className="form-title1">Request a Free Consultation Call</h2>
              <p className="form-subtitle1">
                No account required — just tell me how to contact you.
              </p>
            </header>

            <form className="coaching-form1" onSubmit={handleSubmit} noValidate>
              {/* Honeypot (invisibile) */}
              <div className="hp-field1" aria-hidden>
                <label>
                  Company
                  <input
                    name="company"
                    autoComplete="off"
                    tabIndex={-1}
                    value={form.company}
                    onChange={onChange}
                  />
                </label>
              </div>

              <div className="form-grid1">
                <div className="form-group1">
                  <label htmlFor="fullName">Full name *</label>
                  <input
                    id="fullName"
                    name="fullName"
                    value={form.fullName}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="form-group1">
                  <label htmlFor="email">Email *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="form-group1">
                  <label htmlFor="phone">Phone (optional)</label>
                  <input
                    id="phone"
                    name="phone"
                    value={form.phone}
                    onChange={onChange}
                    placeholder="+39 …"
                  />
                </div>

                <div className="form-group1">
                  <label htmlFor="preferredContact">Preferred contact</label>
                  <select
                    id="preferredContact"
                    name="preferredContact"
                    value={form.preferredContact}
                    onChange={onChange}
                  >
                    <option value="email">Email</option>
                    <option value="whatsapp">WhatsApp</option>
                    <option value="call">Phone call</option>
                  </select>
                </div>

                <div className="form-group1">
                  <label htmlFor="bestTime">Best time to reach you</label>
                  <select
                    id="bestTime"
                    name="bestTime"
                    value={form.bestTime}
                    onChange={onChange}
                  >
                    <option value="any">Anytime</option>
                    <option value="morning">Morning</option>
                    <option value="afternoon">Afternoon</option>
                    <option value="evening">Evening</option>
                  </select>
                </div>
              </div>

              <div className="form-group1">
                <label htmlFor="message">
                  Your goals / what you’d like to discuss *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={6}
                  value={form.message}
                  onChange={onChange}
                  required
                  placeholder="Tell me briefly about your goals, injuries, deadline, etc."
                />
              </div>

              <div className="form-check1">
                <input
                  id="consent"
                  name="consent"
                  type="checkbox"
                  checked={form.consent}
                  onChange={onChange}
                  required
                />
                <label htmlFor="consent">
                  I agree to be contacted regarding my request. *
                </label>
              </div>

              <div className="form-actions1">
                <button
                  type="submit"
                  className="btn-primary1"
                  disabled={status.sending}
                >
                  {status.sending ? "Sending…" : "Request Call"}
                </button>
              </div>

              {/* Successo: spostato nel modal (NEW) */}
              {status.ok === false && status.error && (
                <p className="form-alert1 error1" role="alert">
                  {status.error}
                </p>
              )}

              <input type="hidden" name="lead_source" value={leadSource} />
            </form>
          </Col>
        </Row>
      </Container>

      {/* Modal di conferma invio (NEW) */}
      {/* Modal di conferma invio (NEW) */}
<Modal
  show={showModal}
  onHide={handleCloseModal}
  centered
  aria-labelledby="contact-success-title"
  onEntered={() => closeBtnRef.current?.focus()}
  dialogClassName="confirm-modal1"
  contentClassName="confirm-modal-content1"
  backdropClassName="confirm-modal-backdrop1"
>
  <Modal.Header closeButton className="confirm-modal-header1">
    <Modal.Title
      id="contact-success-title"
      className="confirm-modal-title1"
    >
      Request sent successfully
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="confirm-modal-body1">
    <div className="confirm-modal-icon1" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="24" height="24" focusable="false">
        <path
          d="M9 12.75l-2-2a1 1 0 10-1.41 1.41l2.7 2.7a1 1 0 001.41 0l7.7-7.7A1 1 0 0016.99 5L9 12.75z"
          fill="currentColor"
        />
      </svg>
    </div>

    <p className="confirm-modal-text1">
      Thank you! I’ll get in touch with you soon at the email address you
      provided.
    </p>
    <p className="confirm-modal-sub1">
      You can close this window and continue browsing.
    </p>
  </Modal.Body>

  <Modal.Footer className="confirm-modal-footer1">
    <Button
      ref={closeBtnRef}
      onClick={handleCloseModal}
      className="text-light btn-primary1 btn-modal1"
    >
      Chiudi
    </Button>
  </Modal.Footer>
</Modal>

    </section>
  );
}
